export default "__VITE_ASSET__BwBhht3w__"